import React, { useState, useEffect } from 'react';
import  apiClient  from '../../../../../services/apiClient';
import { predictionParams } from '../../data/agecategory';

import './prediction.css';

const headerName = [
    'Ймовірність отримання запрошення', 
    'Заяв попереду', 
    'Вільних місць'
];

const periodStart = new Date().getMonth() < 8 ? 
    new Date().getFullYear() - 1 : 
    new Date().getFullYear();

export function PredictionQueue({kg, application}) {

    const pred_info = predictionParams(application);


    const { age, ageCategory, ageCategoryType } = pred_info;

    const { queueNumber, specialization } = application;

    const kindergarten = kg._id;
    
    const initialYear = periodStart >= ageCategory.learnYear ? periodStart : ageCategory.learnYear;
    const [selYear, setSelYear] = useState(initialYear);
    const [info, setInfo] = useState({});
    const [showTable, setShowTable] = useState(false);
    const [periodStartState] = useState(initialYear);

    const text_select_label = 'Оберіть навчальний рік';
    const text_age_category = 'Вікова категорія:';

const getInfo = async (qnumber, kindergarten, period, age, specialization) => {
    try {
        const link = `position_in_queue?qnumber=${qnumber}&kindergartens=${kindergarten}&period=${period}&age=${age === 2.5 ? 2 : age}${specialization ? '&specialization=' + specialization : ''}`;
        const response = await apiClient.get(link);
        
        if (response.data && response.data.length > 0) {
            let obj_position = {};

            obj_position['result'] = response.data[0].result;
            obj_position['count_queue'] = response.data[0].count_queue;

            if (response.data[0].pre_info && 
                response.data[0].pre_info[0] && 
                response.data[0].pre_info[0].result && 
                response.data[0].pre_info[0].result[0]) {
                obj_position.result[0].numChild += response.data[0].pre_info[0].result.reduce(function (sum, cur) { 
                    return sum + cur.numChild;
                }, 0);
            }

            setInfo(obj_position);
            setShowTable(true);
        }
    } catch (error) {
        console.log('Error. ' + error);
    }
};

    useEffect(() => {
        getInfo(queueNumber, kindergarten, periodStartState, age, specialization?.specializationId || null);
    }, [queueNumber, kindergarten, periodStartState, age]);

    const changeYear = (e) => {
        const newYear = parseInt(e.target.value);
        setSelYear(newYear);
        setShowTable(false);
        getInfo(queueNumber, kindergarten, newYear, age + (newYear - periodStartState),  specialization?.specializationId || null);
    };

    return (
        <div className="cabinet-predict" id="root-predict">
            <div id="predict-select-year">
                <div>
                    <span>{text_select_label}</span>
                    <SelectYear 
                        selYear={selYear} 
                        changeYear={changeYear} 
                        periodStart={periodStartState} 
                    />
                </div>
                <div className="cabinet-predict-age-category">
                    <div className="cabinet-predict-age-category-label">
                        {text_age_category}{' '}{ageCategoryType[selYear]}
                    </div>
                    <div className="cabinet-predict-age-category-value"></div>
                </div>
            </div>
            <PredictionInfo 
                showTable={showTable}
                info={info}
                ageCategoryMin={(ageCategoryType[selYear].match(/2/) || ageCategoryType[selYear].match(/1/)) && (selYear > periodStart)}
            />
        </div>
    );
}

function PredictionInfo(props) {
    const { showTable, info, ageCategoryMin } = props;
    
    const text_not_info = 'Не має інформації щодо обраного періоду. Можливо ще не створені групи. Перевірте через деякий час.';

    if (!showTable) return <div>{text_not_info}</div>;

    let totalFreeSpaces = 0;
    
    if (info.result) {
        info.result.forEach(el => {
            // Для каждой группы считаем свободные места отдельно
            const totalSpaces = (el.numSit_sleep || 0) + (el.numSit_wobed || 0) + (el.numSit_incl || 0);
            const freeSpaces = totalSpaces - (el.numChild || 0);
            
            if (freeSpaces > 0) {
                totalFreeSpaces += freeSpaces;
            }
        });
    }

    let statusIndex = totalFreeSpaces > 0 ? 
        (info.count_queue || 0) / totalFreeSpaces : 
        (info.count_queue || 0) + 1;

    let statusText = 'Малоймовірно';

    if (ageCategoryMin) statusIndex -= 0.7;
    
    if (statusIndex <= 1) statusText = 'Відмінні шанси';    
    if (statusIndex > 1 && statusIndex < 1.5) statusText = 'Високі шанси';
    if (statusIndex > 1.5 && statusIndex < 3) statusText = 'Середні шанси';

    return (
        <div>
            <div className="table-prediction-info">
                <table>
                    <thead>
                        <HeaderTable />
                    </thead>
                    <tbody>
                        <tr>
                            <td>{statusText}</td>
                            <td>{info.count_queue}</td>
                            <td>{totalFreeSpaces > 0 ? totalFreeSpaces : 0}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <span className="predict-remark-info">Увага! Кількість місць є фактичною на цей момент.</span>
        </div>
    );
}

function HeaderTable() {
    return (
        <tr>
            {headerName.map((headname, index) => (
                <td key={index}>
                    <span className="header-cell-content">{headname}</span>
                </td>
            ))}
        </tr>
    );
}

function SelectYear(props) {
    const { selYear, changeYear, periodStart } = props;
    
    let periods = [];

    for (let i = periodStart; i < periodStart + 2; i++) {
        periods.push(i);
    }
    
    return (
        <select onChange={changeYear} value={selYear}>
            {periods.map(period => (
                <option key={period} value={period}>
                    {period}{'/'}{period + 1}
                </option>
            ))}
        </select>
    );
}